import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { AppStore } from 'src/app/core/app.store'
import { QuickbooksService } from 'src/app/core/services/accounts/quickbooks-service.service'
import { XeroService } from 'src/app/core/services/accounts/xero-service.service'
import { CalloutComponent } from 'src/app/shared/components/callout/callout/callout.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'

@Component({
    selector: 'sf-integrated-accounts-selector',
    imports: [RouterLink, CalloutComponent, ButtonComponent],
    templateUrl: './integrated-accounts-selector.component.html',
    styleUrl: './integrated-accounts-selector.component.scss',
})
export class IntegratedAccountsSelectorComponent {
    appStore = inject(AppStore)
    #toastr = inject(ToastrService)

    #xeroService = inject(XeroService)
    #quickbooksService = inject(QuickbooksService)

    selectXero(): void {
        this.#xeroService.authorize().subscribe({
            next: (url) => {
                window.location.href = url
            },
            error: (error) => {
                this.#toastr.error('Failed to connect to Xero, please try again or contact support.')
            },
        })
    }

    selectQuickbooks(): void {
        this.#quickbooksService.authorize().subscribe({
            next: (url) => {
                window.location.href = url
            },
            error: (error) => {
                this.#toastr.error('Failed to connect to Quickbooks, please try again or contact support.')
            },
        })
    }
}
